// pop-up-login-flow/authPopup.ts
import { BaseQLClient } from "@adornis/baseql/client/baseqlClient.js";
import { baseConfig } from "@adornis/config/baseConfig.js";
import { subscribeCurrentUser } from "@adornis/users/client/currentUser.js";
import { safeParse } from "./messages.js";
var popupAuthFlow = async (popupUrl) => {
  return new Promise((resolve) => {
    console.log("popupAuthFlow", popupUrl);
    const popupTarget = new URL(popupUrl);
    popupTarget.searchParams.set("successRedirect", "/api/popup-auth?done=1");
    popupTarget.searchParams.set("errorRedirect", "/api/popup-auth?done=1");
    const tmpTarget = new URL("/api/popup-auth", baseConfig.get("ROOT_URL"));
    const popup = window.open(tmpTarget.href, "_blank", "popup=true,width=600,height=600");
    if (!popup) {
      console.error("Popup could not be opened");
      resolve(new Error("Popup could not be opened"));
      return;
    }
    const handler = (event) => {
      console.log("popupAuthFlow message", event.data, event.origin);
      if (event.origin !== popupTarget.origin)
        return;
      const { parsed, error } = safeParse(event.data);
      if (error) {
        console.error("Error parsing message:", error);
        resolve(new Error("Error parsing message"));
        return;
      }
      if (parsed.type === "done") {
        window.removeEventListener("message", handler);
        clearInterval(interval);
        if (parsed.error_message) {
          resolve(new Error(parsed.error_message));
          return;
        }
        subscribeCurrentUser();
        resolve(null);
        return;
      }
      if (parsed.type === "ready") {
        popup.postMessage(
          JSON.stringify({
            type: "init",
            origin: window.location.origin,
            sessionID: BaseQLClient.sessionID,
            targetUrl: popupTarget.href
          }),
          popupTarget.origin
        );
        return;
      }
    };
    const interval = setInterval(() => {
      popup.postMessage(JSON.stringify({ type: "ping" }), popupTarget.origin);
    }, 1e3);
    window.addEventListener("message", handler);
  });
};
export {
  popupAuthFlow
};
